// extracted by mini-css-extract-plugin
module.exports = {"text":"bodyCopySkins-smallOnWide-text-6cc27393"};